

exports.__esModule = true;

var _squid = require('squid');

var _angular = require('angular');

var _auth = require('xo-models/src/auth');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryOverlayDirective', {
    tag: 'xo-password-recovery-overlay',
    template: _template2['default'],
    props: {
        token: {
            type: 'var'
        },
        cancel: {
            type: 'var'
        },
        success: {
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            var auth = _auth.$AuthModel.instance();

            _angular.$rootScope.$emit('loading');

            var hideOverlay = function hideOverlay(callback) {
                $('#wrapper #spinner').attr('style', '');
                _this.$element.removeClass('overlayOpen');
                (0, _angular.$timeout)(function () {
                    return callback();
                }, 300);
            };

            this.hideModal = function (event) {
                event.preventDefault();
                hideOverlay(auth.password_less ? _this.cancel : _this.success);
            };

            this.onPasswordRecoveryReady = function () {
                (0, _angular.$timeout)(function () {
                    _angular.$rootScope.$emit('loaded');
                    _this.$element.addClass('overlayOpen');
                });
            };

            this.onContinue = function () {
                hideOverlay(_this.success);
            };

            this.onPasswordRecovery = function () {
                auth.password_less = false;
            };
        }
    }
});


_squid.$Component;

_angular.$rootScope;

_angular.$timeout;

_auth.$AuthModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-login-components/src/password-recovery-overlay/directive.js
// module id = ./components/xo-login-components/src/password-recovery-overlay/directive.js
// module chunks = 1